import { type Channel, ProductType } from "@/api_client";
import { TravelEntryForm } from "@/components/products/travel/entry/TravelEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import type { Locales } from "@/graphql/generated";
import { useEntryContentExternal } from "@/services/cms/tanstackQuery/hooks/useEntryContentExternal";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type TravelEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function TravelEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<TravelEntryProps>) {
  const { isLoading, isSubmitting, submitEntryHandler, policyHolder, user } =
    useEntryForWebComponents({
      productType: "travel",
      backendHost,
      appPathPrefix,
      skipCart,
      channel,
      language,
    });

  const { data: content, isLoading: isLoadingContent } =
    useEntryContentExternal({
      product: ProductType.TRAVEL,
      language: language as Locales,
      appPathPrefix,
    });

  if (isLoading || isLoadingContent) return <ProductContainer.Loader />;

  return (
    <TravelEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
